export default {
  // nhập khẩu danh mục chi thường xuyên
  RegularExpense: 'regular_expense',
  RevenueBusiness: 'revenue_business',
  InvestExpense: 'invest_expense',

  // Dự toán chi thường xuyên
  EstimateRegularXa: 'estimate_regular_xa',
  EstimateRegularHCSN: 'estimate_regular_hcsn',

  // nhập khẩu dữ liệu năm trước đơn vị xã
  BeforeDataVillage: 'before_data_village',
  // nhập khẩu dữ liệu năm trước đơn vị hcsn
  BeforeDataHCSNC3: 'before_data_hcsn_c3',
  // nhập khẩu dữ liệu năm trước PTC(tổng hợp)
  BeforeDataPTCSumary: 'before_data_ptc_summary',
  // nhập khẩu dữ liệu năm hiện hành PTC(tổng hợp)
  BeforeDataCurrentYearPTCSumary: 'before_current_year_data_ptc_summary',
  // nhập khẩu dữ liệu năm trước STC(tổng hợp)
  BeforeDataSTCSumary: 'before_data_stc_summary',
  // nhập khẩu dữ liệu năm hiện hành STC(tổng hợp)
  BeforeDataCurrentYearSTCSumary: 'before_current_year_data_stc_summary',
  // nhập khẩu dữ liệu năm trước đơn vị hcsn
  BeforeDataCurrentYearHCSNC3: 'before_current_year_data_hcsn_c3',
  // nhập khẩu dữ liệu năm trước đơn vị hcsn
  BeforeCurrentYearDataVillage: 'before_current_year_data_village',
  // Xuất khẩu dữ liệu năm trước
  BeforeCurrentYearDataVillageFull: 'before_current_year_data_village_full',

  // nhập khẩu dữ liệu năm trước đơn vị xã
  BeforeDataVillageExportGrid: 'before_data_village_export_grid',
  // nhập khẩu dữ liệu năm trước đơn vị hcsn
  BeforeDataHCSNC3ExportGrid: 'before_data_hcsn_c3_export_grid',
  // nhập khẩu dữ liệu năm trước đơn vị hcsn
  BeforeDataCurrentYearHCSNC3ExportGrid: 'before_current_year_data_hcsn_c3_export_grid',
  // nhập khẩu dữ liệu năm trước đơn vị hcsn
  BeforeCurrentYearDataVillageExportGrid: 'before_current_year_data_village_export_grid',

  /**
   * Nhập khẩu thuyết minh lương CBNV
   */
  RegularSalary: 'regular_salary',

  EstimateArrgrateRegular: 'estimate_arrgrate_regular',
  EstimateArrgrateRegularSTC: 'estimate_arrgrate_regular_stc',
  EstimateArrgrateRegularDetailSTC: 'estimate_arrgrate_regular_detail_stc',
  EstimateSectorWideRegular: 'estimate_sector_wide_regular',
  EstInitialRegularSalary: 'est_initial_regular_salary',
};
